import { createContext, useContext } from "react";

export const AuthorizationContext = createContext();
export const useAuthorization = () => useContext(AuthorizationContext);
